<div class="row" *ngIf="widgetType">
  <div class="col-lg-3">
    <div class="form-group input-group-sm">
      <label>Name</label>
      <input type="text" placeholder="name" class="form-control" [(ngModel)]="w.name">
    </div>
  </div>
  <div class="col-lg-6">
    <div class="form-group input-group-sm">
      <label>Period</label>
      <!--<input type="text" placeholder="period" class="form-control" [(ngModel)]="w.period">-->      
      <app-time-period [(period)]="w.period" [type]="'text'"></app-time-period>
    </div>
  </div>
  <div class="col-lg-3">
    <div class="form-group input-group-sm">
      <label>Widget Size</label>
      <select [(ngModel)]="w.size" class="input-group form-select">
        <option value="4">4</option>
        <option value="5">5</option>
        <option value="6">6</option>
        <option value="7">7</option>
        <option value="8">8</option>
        <option value="9">9</option>
        <option value="10">10</option>
        <option value="11">11</option>
        <option value="12">12</option>
      </select>
    </div>
  </div>
  <div class="col-lg-6">
    <div class="form-group input-group-sm">
      <label>Select Primary Data Source</label> 
      <app-uri-select [customerId]="dashboard.customerId" [timeSeriesDetail]="w.timeSeriesList[0]" [enableMediaSearch]="true" [enableTimeSeriesSearch]="false" [enableTagMatch]="true" [siteTypeCode]="dashboard.siteType" [siteUri]="siteUri"></app-uri-select> 
      <!--<app-time-series-select [timeSeriesDetail]="w.timeSeriesList[0]" [type]="'Media'"></app-time-series-select>-->
    </div>
  </div>
  <div class="col-lg-6">
    <div class="list-group mt-3">

      <div class="list-group-item d-flex align-items-center">
        <div class="flex-fill">
          <div class="fw-bold">Auto Play Video</div>
          <!--<div class="small text text-opacity-50">3,392 data collected</div>-->
        </div>
        <div>
          <div class="form-switch me-n1">
            <input type="checkbox" class="form-check-input" id="customSwitch1" [(ngModel)]="widget.autoPlayVideo">
            <label class="form-check-label" for="customSwitch1"></label>
          </div>
        </div>
      </div>

      <div class="list-group-item d-flex align-items-center">
        <div class="flex-fill">
          <div class="fw-bold">Show Meta Data</div>
          <div class="small text text-opacity-50">Show image overlays for AI analysis</div>
        </div>
        <div>
          <div class="form-switch me-n1">
            <input type="checkbox" class="form-check-input" id="customSwitch2" [(ngModel)]="widget.showImageMetaData">
            <label class="form-check-label" for="customSwitch2"></label>
          </div>
        </div>
      </div>

      <div class="list-group-item d-flex align-items-center">
        <div class="flex-fill">
          <div class="fw-bold">Carousel Enabled</div>
        </div>
        <div>
          <div class="form-switch me-n1">
            <input type="checkbox" class="form-check-input" id="customSwitch3" [(ngModel)]="widget.carouselEnabled">
            <label class="form-check-label" for="customSwitch3"></label>
          </div>
        </div>
      </div>

      <div class="list-group-item d-flex align-items-center">
        <div class="flex-fill">
          <div class="fw-bold">Show Title</div>
        </div>
        <div>
          <div class="form-switch me-n1">
            <input type="checkbox" class="form-check-input" id="customSwitch4" [(ngModel)]="widget.showTitle">
            <label class="form-check-label" for="customSwitch4"></label>
          </div>
        </div>
      </div>

    </div>
    
  </div>
</div>